import type React from 'react'; // Explicitly import React for React.ReactNode

// SiteHeader and AppSidebar are no longer imported here as they are handled by MainLayout

interface AdminLayoutProps {
  children: React.ReactNode;
}

/**
 * AdminLayout now acts as a conceptual wrapper for admin pages.
 * The actual structural layout (sidebar, header, main content area) is provided by MainLayout.
 * AdminLayout simply passes its children through to be rendered within MainLayout's <Outlet />.
 */
export function AdminLayout({ children }: AdminLayoutProps) {
  // AppSidebar and SiteHeader are rendered by MainLayout.
  // AdminLayout's primary role is to be a conceptual wrapper for admin pages.
  // The actual page content (children) will be rendered within MainLayout's <main> tag via <Outlet />.
  // AdminLayout itself doesn't need to provide complex flex structures or its own <main> tag,
  // as that would lead to nesting issues like <main> inside <main>.
  // We return children directly using a React Fragment.
  // Page-specific padding or wrappers should be handled by the individual page components
  // (e.g., AdminUsersPage, AdminProductsPage) if needed.
  return <>{children}</>;
}